<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="contact?.name"
      [canGoBack]="!windowService.isDesktopRes" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded && contact) {

      <!-- Contact summary -->
      <tidy-card>
        <tidy-row class="vertical-align-center">
          <tidy-initials-icon [fullName]="contact.name" />
          <tidy-text [header]="contact.name" [translate]="false" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/svg/mail-outline.svg'" class="body-size" />
          <tidy-text [body]="contact.email" [translate]="false" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/svg/call-outline.svg'" class="body-size" />
          <tidy-text [body]="contact.phone" [translate]="false" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/svg/home-outline.svg'" class="body-size" />
          <tidy-text [body]="propertiesLabel" [translate]="false" />
        </tidy-row>
        <tidy-row [alignLastItemRight]="true">
          <tidy-text [body]="'Stays'" />
          <tidy-text [body]="contact.stays + '  ·  ' + contact.source" [translate]="false" />
        </tidy-row>
      </tidy-card>

      <!-- Tenant portal -->
      <tidy-row><tidy-text [title]="'Tenant Portal'" /></tidy-row>
      <tidy-card>
        <tidy-row>
          <tidy-text [helper]="'A secure link to ' + contact.name + '’s portal, where they can pay rent, submit maintenance requests, and see their lease. Copy it or send it to them.'" [translate]="false" />
        </tidy-row>
        <tidy-row class="extra-top-padding">
          <tidy-text [body]="portalLink" [translate]="false" [ngStyle]="{ 'word-break': 'break-all', 'color': '#1a8e9c' }" />
        </tidy-row>
      </tidy-card>
      <tidy-row class="extra-top-padding">
        <tidy-button [text]="'Copy Portal Link'" [action]="copyPortalAction" class="primary" />
      </tidy-row>
      <tidy-row>
        <tidy-button [text]="'Send via Messages'" [action]="sendPortalAction" class="secondary" />
      </tidy-row>

      <!-- Lease & ledger -->
      @if (leases.length) {
        <tidy-row><tidy-text [title]="'Lease'" /></tidy-row>
        @for (lease of leases; track lease.id) {
          <tidy-card>
            <tidy-row [alignLastItemRight]="true" class="vertical-align-center">
              <tidy-text [body]="lease.property_name + ' · ' + (lease.space_name || lease.unit)" [translate]="false" />
              <tidy-text [body]="lease.status" [translate]="false" [ngStyle]="{ color: leaseStatusColor(lease.status) }" />
            </tidy-row>
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="rentDisplayByLeaseId.get(lease.id)" [translate]="false" />
              <tidy-text [body]="balanceLabel(leaseBalance(lease))" [translate]="false" [ngStyle]="{ color: balanceColor(leaseBalance(lease)) }" />
            </tidy-row>
          </tidy-card>
          <tidy-row class="extra-top-padding">
            <tidy-button [text]="'View Ledger'" [action]="viewLedger.bind(this, lease)" class="secondary" />
          </tidy-row>
        }
      }

      <!-- Tenant screening -->
      <tidy-row><tidy-text [title]="'Tenant Screening'" /></tidy-row>

      @if (screening) {
        <tidy-card>
          <tidy-row [alignLastItemRight]="true" class="vertical-align-center">
            <div class="vertical-align-center" style="display:flex; align-items:center;">
              <div [ngStyle]="{ 'width': '11px', 'height': '11px', 'border-radius': '50%', 'background-color': recommendationColor(screening.recommendation), 'margin-right': '8px', 'flex-shrink': '0' }"></div>
              <tidy-text [body]="recommendationLabel(screening.recommendation)" [translate]="false" [ngStyle]="{ color: recommendationColor(screening.recommendation) }" />
            </div>
            <tidy-text [body]="screening.status" [translate]="false" [ngStyle]="{ color: statusColor(screening.status) }" />
          </tidy-row>
          @if (screening.status === 'Completed') {
            <tidy-row [alignLastItemRight]="true" class="extra-top-padding">
              <tidy-text [body]="'Credit Score'" />
              <tidy-text [body]="(screening.credit_score || '—') + '  ·  ' + creditBand(screening.credit_score)" [translate]="false" />
            </tidy-row>
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="'Income'" />
              <tidy-text [body]="screening.income_verified ? ('Verified · ' + (screening.income_to_rent_ratio | number:'1.1-1') + 'x rent') : 'Not verified'" [translate]="false" />
            </tidy-row>
          }
        </tidy-card>

        <tidy-row class="extra-top-padding">
          <tidy-button [text]="'View Full Report'" [action]="viewReportAction" class="primary" />
        </tidy-row>
      }

      @if (!screening) {
        <tidy-alert>
          <tidy-row>
            <tidy-text [body]="'No screening on file for ' + contact.name + '. Send a secure FCRA screening invite to run a credit, criminal, and eviction check.'" [translate]="false" />
          </tidy-row>
        </tidy-alert>
        <tidy-row class="extra-top-padding">
          <tidy-button
            [text]="isOrdering ? 'Sending invite…' : 'Order a Screening'"
            [action]="orderScreeningAction"
            class="primary" />
        </tidy-row>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
